@if (userData(); as user) {
  <section class="profile-details">
    <div class="profile-details-tabs">
      <span class="profile-details-tab-active">{{ 'user-profile.general' | translate }}</span>
      <span>{{ 'user-profile.employment' | translate }}</span>
    </div>
    @if (editMode()) {
      <form
        [formRoot]="form"
        class="profile-edit-form"
      >
        <fieldset [disabled]="saving()">
          <legend>{{ 'user-profile.personal' | translate }}</legend>
          <proffeo-ui-input
            [label]="'user-profile-page.basic-data-view.last-name-control' | translate"
            [formField]="form.lastName"
          />
          <proffeo-ui-input
            [label]="'user-profile-page.basic-data-view.first-name-control' | translate"
            [formField]="form.firstName"
          />
          @if (showNameError()) {
            <p
              role="alert"
              class="profile-error"
            >
              {{ 'user-profile-page.basic-data-view.empty-name-validation-msg' | translate }}
            </p>
          }
        </fieldset>
        <fieldset [disabled]="saving()">
          <legend>{{ 'user-profile.contact' | translate }}</legend>
          <div class="profile-email">
            <span>{{ 'user-profile-page.basic-data-view.email-control' | translate }}</span>
            <p>{{ user.email || '—' }}</p>
            <small>{{ 'user-profile-page.basic-data-view.email-edit-unavailable' | translate }}</small>
          </div>
          <proffeo-ui-input
            [label]="'user-profile-page.basic-data-view.phone-number-control' | translate"
            [formField]="form.phoneNumbers"
          />
          <proffeo-ui-input
            [label]="'user-profile-page.basic-data-view.address-control' | translate"
            [formField]="form.address"
          />
          @if (showPhoneNumberError()) {
            <p
              role="alert"
              class="profile-error"
            >
              {{ 'user-profile-page.basic-data-view.invalid-phone-number-validation-msg' | translate }}
            </p>
          }
          <proffeo-ui-textarea
            [label]="'user-profile-page.basic-data-view.notes-control' | translate"
            [formField]="form.notes"
          />
        </fieldset>
        <div class="profile-form-actions">
          <proffeo-ui-button
            (clicked)="cancelEditMode()"
            [disabled]="saving()"
            [text]="'user-profile-page.basic-data-view.cancel-edit-button' | translate"
          />
          <proffeo-ui-button
            (clicked)="updateUserBasicData()"
            [loading]="saving()"
            [disabled]="saving()"
            [text]="'user-profile-page.basic-data-view.save-button' | translate"
            variant="accent"
          />
        </div>
      </form>
    } @else {
      <div class="profile-details-body">
        <proffeo-ui-button
          (clicked)="toggleEditMode()"
          [ariaLabel]="'user-profile-page.basic-data-view.edit-data-button' | translate"
          [tooltip]="'user-profile-page.basic-data-view.edit-data-button' | translate"
          fontIcon="edit"
        />
        <mat-accordion multi>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'user-profile.personal' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <dl class="profile-fields">
              @for (field of personalFields(); track field.key) {
                <div>
                  <dt>{{ 'user-profile-page.basic-data-view.' + field.key | translate }}</dt>
                  <dd>{{ field.value || '—' }}</dd>
                </div>
              }
            </dl>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'user-profile.contact' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <dl class="profile-fields">
              @for (field of contactFields(); track field.key) {
                <div>
                  <dt>{{ 'user-profile-page.basic-data-view.' + field.key | translate }}</dt>
                  <dd>{{ field.value || '—' }}</dd>
                </div>
              }
            </dl>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'user-profile-page.basic-data-view.notes-control' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <p class="profile-notes">{{ user.notes || '—' }}</p>
          </mat-expansion-panel>
        </mat-accordion>
        <dl class="profile-fields profile-account">
          <div>
            <dt>{{ 'user-profile-page.basic-data-view.status' | translate }}</dt>
            <dd><proffeo-user-status [userStatus]="user.status" /></dd>
          </div>
          <div>
            <dt>{{ 'user-profile-page.basic-data-view.created-at' | translate }}</dt>
            <dd>{{ user.createdAt | proffeoDate: defaultDatetimeFormat }}</dd>
          </div>
          @if (user.updatedAt) {
            <div>
              <dt>{{ 'user-profile-page.basic-data-view.updated-at' | translate }}</dt>
              <dd>{{ user.updatedAt | proffeoDate: defaultDatetimeFormat }}</dd>
            </div>
          }
        </dl>
      </div>
    }
  </section>
}
